import Cookies from 'js-cookie';
import { setDatForAddressRecovery } from '../../Utils/addressUtils';
import { getCountry } from '../../Utils/ForeignUtils';
import { getScreenName } from '../../Utils/helper';
import { getPricingAndConversionParamsPage } from '../CartOverlayContainer/Cart/instrumentation';
import { MobileValidator, pincodeValidator } from './utils';
import { fireEvent } from '../../Utils/fireEvent';

export const fireEnteredValueEvents = (category, value, isAutoFetched) => {
  fireEvent({
    category: category,
    screen_name: getScreenName(),
    value: value,
    auto_fetched: isAutoFetched,
  });
};
export const fireViewedAddressPageEvent = (priceDetails) => {
  const { pricing_param, uniqueIds } = getParamsAndids(priceDetails);
  fireEvent({
    category: 'viewed_new_address_page',
    screen_name: getScreenName(),
    pricing_param,
    id: uniqueIds,
    sku_type: 'product',
  });
};

export const getParamsAndids = (priceDetails) => {
  const { pricing_param, conversion_param } =
    getPricingAndConversionParamsPage(priceDetails);
  let cart_id = Cookies.get('cart_items');
  const array = cart_id?.split(',');
  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  };
  const uniqueIds = array?.filter(onlyUnique);
  return { pricing_param, uniqueIds };
};

export const firesaveAddressEvent = (addressForm, cartData) => {
  let obj = [];
  let homeOfficeValue = null;
  let isDefault = 0;
  let supportVariableObj = {};
  addressForm.map((element) => {
    if (element?.required && element?.value === '') {
      obj.push(element.id);
    }
    if (
      element?.required &&
      element?.id === 'zipcode' &&
      !pincodeValidator(element?.value)
    ) {
      obj.push(element.id);
    }
    if (
      element?.required &&
      element?.id === 'mobile' &&
      !MobileValidator(element?.value)
    ) {
      obj.push(element.id);
    }
    if (element?.id == 'address_type') homeOfficeValue = element?.value;
    if (element?.id == 'is_default') isDefault = 1;
  });
  supportVariableObj = {
    address_type: homeOfficeValue,
    default_address: isDefault,
  };
  const { pricing_param, uniqueIds } = getParamsAndids(
    cartData?.data?.priceDetails,
  );
  const fieldAddressEncrypted = setDatForAddressRecovery(addressForm);
  const cartItems = Cookies.get('cart_items');
  fireEvent({
    category: 'saved_new_address',
    screen_name: getScreenName(),
    pricing_param,
    sku_id: uniqueIds,
    sku_type: 'product',
    valid_address: obj.length == 0 ? 1 : 0,
    unfilled_mandatory_fields: obj,
    support_variable: supportVariableObj,
    country: getCountry(),
    product_ids: cartItems,
    ...fieldAddressEncrypted,
  });
};
export const fireEventHandler = (category, supportVariable) => {
  fireEvent({
    category: category,
    screen_name: getScreenName(),
    support_variable: supportVariable,
  });
};
